<div class="d-flex justify-content-center spinner-wrapper" style="height: 100%;">
    <div class="spinner-border" role="status" style="width: 5rem; height: 5rem;">
      <span class="sr-only"></span>
    </div>
</div>